/**
 * Created by jonas on 2019-08-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { TimelineLite, TweenLite, Timeline} from "gsap";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FadePlate} from "@nolimitcity/slot-game/bin/timelinegameround/components/FadePlate";
import {ImmortalFruitsLayerConfig} from "../config/IImmortalFruitsLayerConfig";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {CoinsFountain} from "./CoinsFountain";
import {Container, Sprite, Graphics} from "pixi.js";
import {IImmortalFruitsWinRatioConfig, ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bonusWheelEvents} from "../gameround/bonusWheelController";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SoundManager} from "../resource/sound/SoundManager";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class bigWinEvents {
    public static readonly PLAY_BIGWIN: string = "bigWinEvents_PLAY_BIGWIN";
    public static readonly STOP_BIGWIN: string = "bigWinEvents_STOP_BIGWIN";
    public static readonly PLAY_GREENLIGHTS: string = "bigWinEvents_PLAY_GREENLIGHTS";
    public static readonly STOP_GREENLIGHTS: string = "bigWinEvents_STOP_GREENLIGHTS";
    public static readonly LEVER_YANKING: string = "bigWinEvents_LEVER_YANKING";

}

export class WinTextView extends BaseView {
    protected _screenRect: PIXI.Rectangle;
    private _mainTl: Timeline | null;
    private _abortedIdle: boolean = false;
    private _layer: ScalableLayer;
    private _Fountainlayer: ScalableLayer;
    private _currentSound: string = "";
    private _coinsFountain: CoinsFountain;
    private _fullScreenFade: FadePlate;
    private _bigWinSpineAnim: PIXI.spine.Spine;
    private _bigWinSpineAnimAbort: Sprite;
    private Frame_light_loop1Left: TimelineSprite;
    private Frame_light_loop1Right: TimelineSprite;
    private Frame_light_loop2Left: TimelineSprite;
    private Frame_light_loop2Right: TimelineSprite;
    private Frame_light_loop3: TimelineSprite[] = [];
    private Frame_light_sweep_Left: TimelineSprite;
    private Frame_light_sweep_Right: TimelineSprite;
    private _maskGreenLights: PIXI.Graphics;
    private _sideEdgeGlowLeft: Sprite;
    private _sideEdgeGlowRight: Sprite;
    private _greenLightsContainer: Container;
    private _gameConfigInstance: ImmortalFruitsGameConfig = ImmortalFruitsGameConfig.instance;
    private isPortrait: boolean = false;
    private greenLightTimeLine: TimelineLite;
    private mainBigTimeLine:TimelineLite|null;
    private _reelBackLayer :ScalableLayer;
    private _nextMode:String;
    private _mode:String;
    constructor() {
        super();
        this._layer = StageManager.getLayer(ImmortalFruitsLayerConfig.BIG_WIN.name);
        this._Fountainlayer = StageManager.getLayer(ImmortalFruitsLayerConfig.BIG_WIN_FOUNTAIN.name);
        this._coinsFountain = new CoinsFountain(this._Fountainlayer);
        EventHandler.addEventListener(this, bigWinEvents.PLAY_GREENLIGHTS, (event: GameEvent) => this.playIdleGreenAnimation(event.params[0]));
        EventHandler.addEventListener(this, bigWinEvents.STOP_GREENLIGHTS, (event: GameEvent) => this.stopIdleGreenAnimation());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }
    private onGameDataParsed(data:ParsedGameData){
        this._nextMode = data.nextMode;
        this._mode = data.mode;
    }
    onResize(data: IResizeData) {

        this._screenRect = new PIXI.Rectangle(0, 0, data.width / this._layer.scale.x, data.height / this._layer.scale.y);
        this._fullScreenFade.visible = true;
        if (data.orientation === Orientation.PORTRAIT) {
            this._bigWinSpineAnim.y = ImmortalFruitsGameConfig.instance.GAME_HEIGHT * 0.18 ;
            this._bigWinSpineAnimAbort.y = ImmortalFruitsGameConfig.instance.GAME_HEIGHT * 0.18;
            this.isPortrait = true;
            this._fullScreenFade.resize(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X -3, ImmortalFruitsGameConfig.instance.PORTRAIT_OFFSET-8, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH * 0.91+2, ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT + 8);
        } else {
            this._bigWinSpineAnim.y = ImmortalFruitsGameConfig.instance.GAME_HEIGHT * 0.28;
            this._bigWinSpineAnimAbort.y = ImmortalFruitsGameConfig.instance.GAME_HEIGHT * 0.28;
            this.isPortrait = false;
            this._fullScreenFade.resize(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X -2 , ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y -2, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH*0.91+2  , ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT+4 );

        }
    }

    public getStartAnimation(config: IWinRatioConfig, _lastLevel?: boolean, isEnd: boolean = false): TimelineLite {
        this._bigWinSpineAnimAbort.alpha=0;
        EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.START_BIGWIN));
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => {
               // if(!(this._mode===ImmortalFruitsGameMode.BONUS_WHEEL && this._nextMode===ImmortalFruitsGameMode.NORMAL)){
                    this._fullScreenFade.getFadeTo(0.1, 0.6);
                //}
                this.getBigWinLevelTimeline(config.text, config.duration, _lastLevel);
            }
        ]);
        this._mainTl = tl;
        return tl;
    }


    /**
     * @description End of any win.
     * @param config
     * @param displayDuration
     * @param fadeOutDuration
     */
    public end(config: IImmortalFruitsWinRatioConfig, displayDuration: number, fadeOutDuration: number): TimelineLite {
        this._bigWinSpineAnimAbort.alpha=0;
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._currentSound = "";

            EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_BIGWIN));
        },displayDuration);
        tl.add(() => {
            this.stopAllAnimations()
            this.killTween();
            this._bigWinSpineAnim.alpha=0;
            this._bigWinSpineAnimAbort.alpha=0;
            this._fullScreenFade.getFadeOut(0.2);
            this._coinsFountain.stopFountain();

            }, displayDuration);


        return tl;
    }

    // #320
    public showBetlineAmountInitialWin(betWins: IBetWinData[]): void {
        const tl: TimelineLite = new TimelineLite(),
            container: PIXI.Container = new PIXI.Container();

        container.position.set(360);
        container.alpha = 0;

        betWins.forEach((betWin: IBetWinData, idx: number) => {
            const winAmount: PIXI.BitmapText = new PIXI.BitmapText(betWin.multipliedAmount.toFixed(2), {
                fontName: "betLineFont",
                fontSize: 15
            });
            let effectiveIdx: number = idx;

            if (betWins.length > 25 && (idx >= (betWins.length / 2))) {
                effectiveIdx = (idx - (betWins.length / 2));
                winAmount.x = (container.children[0] as PIXI.BitmapText).width + 30;
            }

            winAmount.y = (effectiveIdx * 40);
            winAmount.tint = (effectiveIdx % 2 === 0 ? 0x00ff00 : 0x0000ff);

            if (betWins.length > 25) {
                winAmount.pivot.set(winAmount.width / 2, 0);
            }

            container.addChild(winAmount);
        });

        if (betWins.length > 13) {
            container.scale.set(0.65);
            container.y -= 100;
        }
        container.pivot.set(container.width / 2, container.height / 2);

        StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).addChild(container);

        tl.to(container, 0.1, {
            alpha: 1
        });
        tl.to(container, 0.5, {
            y: "-=50"
        });
        tl.to(container, 0.1, {
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChild(container);
        });
    }

    protected initAnimations(): void {
        this._reelBackLayer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._fullScreenFade = new FadePlate(0x000000, 1);
        this._sideEdgeGlowLeft = new Sprite(GameResources.getTextures("left_side_edge_glow")[0]);
        this._sideEdgeGlowRight = new Sprite(GameResources.getTextures("side_edge_glow")[0]);
        this._Fountainlayer.addChild(this._fullScreenFade);
        this.Frame_light_sweep_Left = new TimelineSprite(GameResources.getTextures("Frame_light_sweep"), 13);
        this.Frame_light_sweep_Right = new TimelineSprite(GameResources.getTextures("Frame_light_sweep"), 13);

        this.Frame_light_loop2Left = new TimelineSprite(GameResources.getTextures("Frame_light_loop2"), 30);
        this.Frame_light_loop2Right = new TimelineSprite(GameResources.getTextures("Frame_light_loop2"), 30);
        this.createGreenLights();
        this._bigWinSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("Bigwins"));
       // this._bigWinSpineAnimAbort = new PIXI.spine.Spine(GameResources.getSpineAsset("Bigwins"));
        this._bigWinSpineAnimAbort = new PIXI.Sprite(GameResources.getTextures("bigWinTxt")[0]);
        this._reelBackLayer.addChild(this._sideEdgeGlowRight);
        this._reelBackLayer.addChild(this.Frame_light_sweep_Right);
        this._reelBackLayer.addChild(this._sideEdgeGlowLeft);
        this._reelBackLayer.addChild(this.Frame_light_sweep_Left);

        this._reelBackLayer.addChild(this.Frame_light_loop2Left);
        this._reelBackLayer.addChild(this.Frame_light_loop2Right);
        this._layer.addChild(this._bigWinSpineAnim);
        this._layer.addChild(this._bigWinSpineAnimAbort);


        this._sideEdgeGlowLeft.blendMode = PIXI.BLEND_MODES.ADD;
        this._sideEdgeGlowRight.blendMode = PIXI.BLEND_MODES.ADD;
        this.Frame_light_sweep_Left.blendMode = PIXI.BLEND_MODES.ADD;
        this.Frame_light_sweep_Right.blendMode = PIXI.BLEND_MODES.ADD;

        this.Frame_light_loop2Left.blendMode = PIXI.BLEND_MODES.ADD;
        this.Frame_light_loop2Right.blendMode = PIXI.BLEND_MODES.ADD;



        this.Frame_light_sweep_Left.position.set(-this.Frame_light_sweep_Left.width / 2 - 30, this._gameConfigInstance.REEL_AREA_POS_Y - 30);

        this.Frame_light_sweep_Right.position.set(this._gameConfigInstance.REEL_AREA_WIDTH + 20 + this.Frame_light_sweep_Left.width / 2, this._gameConfigInstance.REEL_AREA_POS_Y - 30);
        this.Frame_light_sweep_Right.scale.x = -1;
        this.Frame_light_loop2Right.scale.x = -1;
        this._bigWinSpineAnim.alpha = 0;

        this._bigWinSpineAnim.pivot.set(0.5);
        this._bigWinSpineAnimAbort.anchor.set(0.5);
        this._bigWinSpineAnim.y = ImmortalFruitsGameConfig.instance.GAME_HEIGHT * 0.28;
        this._bigWinSpineAnimAbort.y = ImmortalFruitsGameConfig.instance.GAME_HEIGHT * 0.28;
        this.Frame_light_loop2Left.x = -44;
        this.Frame_light_loop2Left.y = 65;
        this.Frame_light_loop2Right.position = this.Frame_light_loop2Left.position;
        this.Frame_light_loop2Right.x = this._gameConfigInstance.REEL_AREA_WIDTH + 26;
        this._sideEdgeGlowLeft.position.set(-this._gameConfigInstance.REEL_AREA_POS_X - 11, this._gameConfigInstance.REEL_AREA_POS_Y + 238);
        this._sideEdgeGlowRight.position.set(this._gameConfigInstance.REEL_AREA_WIDTH + this._gameConfigInstance.REEL_AREA_POS_X , this._gameConfigInstance.REEL_AREA_POS_Y + 238);
        this._sideEdgeGlowLeft.anchor.set(0.5);
        this._sideEdgeGlowRight.anchor.set(0.5);
        this._bigWinSpineAnimAbort.alpha=0;
        this.toggleVisibilityAnimations(0);
    }

    /**
     * @inheritDoc
     */
    private createGreenLights() {

        this._greenLightsContainer = new Container();
        this._maskGreenLights = new Graphics();
        this._maskGreenLights.beginFill(0x644A50, 1);
        this._maskGreenLights.visible = true;
        this._maskGreenLights.pivot.set(0.5);

        this.Frame_light_loop3 =[];
        this._greenLightsContainer.removeChildren();
        for (let i = 0; i < 4; i++) {
            this.Frame_light_loop3.push(new TimelineSprite(GameResources.getTextures("Frame_light_loop3"), 8));

            this.Frame_light_loop3[i].anchor.set(0.5);
            this.Frame_light_loop3[i].x = -29;
            this.Frame_light_loop3[i].y = this._gameConfigInstance.REEL_AREA_HEIGHT + 19;
            //if(i>0) this.Frame_light_loop3[i].y = this._gameConfigInstance.REEL_AREA_HEIGHT+25-19;
            this.Frame_light_loop3[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._greenLightsContainer.addChild(this.Frame_light_loop3[i]);
        }
        for (let i = 4; i < 8; i++) {
            this.Frame_light_loop3.push(new TimelineSprite(GameResources.getTextures("Frame_light_loop3"), 8));

            this.Frame_light_loop3[i].anchor.set(0.5);
            this.Frame_light_loop3[i].x = this._gameConfigInstance.REEL_AREA_WIDTH + 19;
            this.Frame_light_loop3[i].y = this._gameConfigInstance.REEL_AREA_HEIGHT + 19;
            //if(i>0) this.Frame_light_loop3[i].y = this._gameConfigInstance.REEL_AREA_HEIGHT+25-19;
            this.Frame_light_loop3[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._greenLightsContainer.addChild(this.Frame_light_loop3[i]);
        }
        this._maskGreenLights.drawRect(this.Frame_light_loop3[0].x - this.Frame_light_loop3[0].width / 2, this.Frame_light_loop3[0].y - this.Frame_light_loop3[0].height / 2, 1.5 * this.Frame_light_loop3[0].width + this._gameConfigInstance.REEL_AREA_WIDTH, this.Frame_light_loop3[0].height)
        this._greenLightsContainer.addChild(this._maskGreenLights)
        this._reelBackLayer.addChild(this._greenLightsContainer);
        this._greenLightsContainer.mask = this._maskGreenLights;

    }

    private resetIdleGreenLight(sourceFPS:number){
        this._reelBackLayer.removeChild(this.Frame_light_loop1Left);
        this._reelBackLayer.removeChild(this.Frame_light_loop1Right);
         this.Frame_light_loop1Left = new TimelineSprite(GameResources.getTextures("Frame_light_loop1"), sourceFPS);
         this.Frame_light_loop1Right = new TimelineSprite(GameResources.getTextures("Frame_light_loop1"), sourceFPS);
         this._reelBackLayer.addChild(this.Frame_light_loop1Left);
         this._reelBackLayer.addChild(this.Frame_light_loop1Right);
         this.Frame_light_loop1Left.blendMode = PIXI.BLEND_MODES.ADD;
         this.Frame_light_loop1Right.blendMode = PIXI.BLEND_MODES.ADD;
         this.Frame_light_loop1Right.scale.x = -1;
         this.Frame_light_loop1Left.x = -69;
         this.Frame_light_loop1Left.y = 7;

         if ( this.isPortrait) {
            this.Frame_light_loop1Right.y = -75;
            this.Frame_light_loop1Left.y = -75;
         } else {
            this.Frame_light_loop1Right.y = 7;
            this.Frame_light_loop1Left.y = 7;
         }
         this.Frame_light_loop1Right.position = this.Frame_light_loop1Left.position;
         this.Frame_light_loop1Right.x = this._gameConfigInstance.REEL_AREA_WIDTH + 40 + 12;  this.Frame_light_loop1Right.alpha=1;
         this.Frame_light_loop1Left.alpha=0;
         this.Frame_light_loop1Right.alpha=0;
    }
    private resetforBigWinGreenLight(){
        this.resetIdleGreenLight(12);
    }
    private playIdleGreenAnimation(animString:string) {
        //console.log("playimgIdle");
        if (animString === "reset") {
            this.resetIdleGreenLight(15);
        } else if (animString === "loop1") {
            this._abortedIdle =false;
            this.Frame_light_loop1Right.alpha=1;
            this.Frame_light_loop1Left.alpha=1;
            this.Frame_light_loop1Left.getAnimation([0],()=>{},()=>{
                this.Frame_light_loop1Right.alpha=0;
                this.Frame_light_loop1Left.alpha=0;


            });
            this.Frame_light_loop1Right.getAnimation();
            this.greenLightTimeLine = null!;
            this.greenLightTimeLine = new TimelineLite({onComplete:()=>{

                }});
            for (let i = 0; i < 4; i++) {
                this.greenLightTimeLine.add(() => {
                    if(!this._abortedIdle){
                        this.Frame_light_loop3[i].alpha = 1;
                        this.Frame_light_loop3[i].getAnimation([0],()=>{},()=>{
                            this.Frame_light_loop3[i].alpha = 0;
                        });
                        this.Frame_light_loop3[i + 4].alpha = 1;
                        this.Frame_light_loop3[i + 4].getAnimation([0],()=>{},()=>{
                            this.Frame_light_loop3[i+4].alpha = 0;
                        });
                    }

                }, i * 0.25);

            }
            this.greenLightTimeLine.add(()=>{
                if(!this._abortedIdle){
                    EventHandler.dispatchEvent(new GameEvent(bigWinEvents.PLAY_BIGWIN, "Idle"));
                };
             },1);
        }
    }
    /**
     * @description To stop Idle Animations on spin
     */
    private stopIdleGreenAnimation(){
        this._abortedIdle =true;
        if(this.Frame_light_loop1Right){
            this.Frame_light_loop1Right!.alpha=0;
        }
        if(this.Frame_light_loop1Left){
            this.Frame_light_loop1Left!.alpha=0;
        }


        EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_BIGWIN));
        if(this.greenLightTimeLine){
            this.greenLightTimeLine.pause();
            this.greenLightTimeLine.clear();
        }
         for (let i = 0; i < 8; i++) {
             if(this.Frame_light_loop3[i]){
             }

             this.Frame_light_loop3[i].alpha = 0;
         }
        this.resetforBigWinGreenLight();


    }
    /**
     * @description To play Green bottom lights in loop during bigwin
     */
    private playBigWinGreenLights() {
        this.greenLightTimeLine =null!;
        this.greenLightTimeLine = new TimelineLite();
        for (let i = 0; i < 4; i++) {
            this.greenLightTimeLine.add(() => {
                this.Frame_light_loop3[i].alpha = 1;
                this.Frame_light_loop3[i].playLoop();
                this.Frame_light_loop3[i+4].alpha = 1;
                this.Frame_light_loop3[i+4].playLoop();
            }, i * 0.25);
        }
    }
    /**
     * @description To clean up the win item.
     */
    private cleanup() {
        //this._winText.text = "";
    }

    /**
     * @description To play the win sound.
     * @param config
     */
    private playWinSound(config: IImmortalFruitsWinRatioConfig) {
        let newSound: string = "";

        if (config.sound) {
            newSound = config.sound;
        }

        if (this._currentSound != newSound) {
            if (this._currentSound != "") {
                SlotGame.sound.stopEffect(this._currentSound);
            }
            SlotGame.sound.playEffect(newSound, 0);
            this._currentSound = newSound;
        }
    }

    private stopAllAnimations() {
        this.Frame_light_loop1Left.stopLoop();
        this.Frame_light_loop1Left.alpha = 0;
        this.Frame_light_loop1Right.alpha = 0;
        this.Frame_light_loop1Right.stopLoop();

        this.Frame_light_loop2Left.stopLoop();
        this.Frame_light_loop2Right.stopLoop();

        this._sideEdgeGlowRight.alpha = 0;
        this._sideEdgeGlowLeft.alpha = 0;
        this.Frame_light_loop2Left.alpha = 0;
        this.Frame_light_loop2Right.alpha = 0;

        for(let index=0;index<8;index++){
            this.Frame_light_loop3[index].alpha = 0;
            this.Frame_light_loop3[index].stopLoop();
        }

    }

    private toggleVisibilityAnimations(show: number) {

        this.Frame_light_loop2Left.alpha = show;
        this.Frame_light_loop2Right.alpha = show;
        this.Frame_light_loop2Right.alpha = show;
        this._sideEdgeGlowLeft.alpha = show;
        this._sideEdgeGlowRight.alpha = show;
        for (let i = 0; i < 8; i++) {
            this.Frame_light_loop3[i].alpha = show;
        }

    }

    private playLight1Anim(){
        this.Frame_light_loop1Left.alpha = 1;
        this.Frame_light_loop1Right.alpha = 1;
        this.Frame_light_loop1Left.playLoop();
        this.Frame_light_loop1Right.playLoop();
    }
    private playLight2Anim(){
        this.Frame_light_loop2Left.alpha = 1;
        this.Frame_light_loop2Right.alpha = 1;
        this.Frame_light_loop2Left.playLoop();
        this.Frame_light_loop2Right.playLoop();
    }

    private stopBigWinLevelSounds(){
        SoundManager.stopBigWinLevel(0);
        SoundManager.stopBigWinLevel(1);
        SoundManager.stopBigWinLevel(2);
    }

    private getBigWinLevelTimeline(level: any, duration: number,_lastLevel:boolean=false): TimelineLite {
        this._bigWinSpineAnimAbort.alpha=0;
        EventHandler.dispatchEvent(new GameEvent(bigWinEvents.PLAY_BIGWIN, level));
        this._bigWinSpineAnim.alpha =0;
        this.playLight1Anim();
        this._bigWinSpineAnim.x = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X - 23-10;
        let levelStr = "";
        if (level === "Big Win") {
            this._coinsFountain.startFountain(0);
            this.stopBigWinLevelSounds();
            SoundManager.playBigWinLevel(0);
            this._bigWinSpineAnim.x = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X - 27-10;
            levelStr = "bigwin";
        } else if (level === "Mega Win") {
            if (!this.isPortrait) {
                this.playLight2Anim()
            }
            this.stopBigWinLevelSounds();
            SoundManager.playBigWinLevel(1);
            this._coinsFountain.startFountain(1);
            this._bigWinSpineAnim.x = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X - 25-10;
            levelStr = "megawin";
        } else if (level === "Super Mega Win") {
            this.playBigWinGreenLights();
            this.stopBigWinLevelSounds();
            SoundManager.playBigWinLevel(2);
            this._coinsFountain.startFountain(2);
            levelStr = "supermegawin";
        }
        if(this.mainBigTimeLine){
            this.mainBigTimeLine!.pause();
            this.mainBigTimeLine!.kill();
            this.mainBigTimeLine = null;
        }

        this.mainBigTimeLine = new TimelineLite();

        this.mainBigTimeLine.add(() => {
            this._bigWinSpineAnim.alpha = 1;
            this._bigWinSpineAnim.state.setAnimation(0, `${levelStr}_start`, false).timeScale =0.5;
            if (!this.isPortrait) {
                this.Frame_light_sweep_Left.getAnimationAutoShowHide();
                this.Frame_light_sweep_Right.getAnimationAutoShowHide();
            }
        }, 0);
        if (levelStr !== "bigwin" && !this.isPortrait) {
            this.mainBigTimeLine.add(() => {
                this.Frame_light_sweep_Left.getAnimationAutoShowHide();
                this.Frame_light_sweep_Right.getAnimationAutoShowHide();
            }, this.Frame_light_sweep_Left.totalDuration);
        }
        if (levelStr === "supermegawin" && !this.isPortrait) {
            new TweenLite(this._sideEdgeGlowLeft, 0.5, {alpha: 1});
            new TweenLite(this._sideEdgeGlowRight, 0.5, {alpha: 1});
            this.mainBigTimeLine.add(() => {
                this.Frame_light_sweep_Left.getAnimationAutoShowHide();
                this.Frame_light_sweep_Right.getAnimationAutoShowHide();
            }, 2 * this.Frame_light_sweep_Left.totalDuration);
        }
        this.mainBigTimeLine.add(() => {
        this._bigWinSpineAnim.state.setAnimation(0, `${levelStr}_loop`, true).timeScale = 0.8;
        }, 1);
        //let endAnimDuration = -0.3;
        //if (!_lastLevel) {
        let endAnimDuration = 0.7;
        //}
            this.mainBigTimeLine.add(() => {
                this._bigWinSpineAnim.state.setAnimation(0, `${levelStr}_end`, false).timeScale = 0.5;
            }, duration - endAnimDuration);


        return this.mainBigTimeLine;
    }

    private playWindUp() {
        // SlotGame.sound.playEffect(BookOfShadowsSoundConfig.BIG_WIN_WIND_UP);
    }
    public abort(_toRatioConfig:any):TimelineLite{
        const tl: TimelineLite = new TimelineLite({onComplete:()=>{
                this._bigWinSpineAnimAbort.alpha=0;
            }});

        this._bigWinSpineAnimAbort.x = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X - 23-10;
        if (_toRatioConfig.text === "Big Win") {
            this._bigWinSpineAnimAbort.alpha=1;
            this._bigWinSpineAnimAbort.x = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X - 27-10;
            TweenLite.to(this._bigWinSpineAnimAbort,0.5,{alpha:0,onComplete:()=>{
                    // this._bigWinSpineAnimAbort.alpha=0;
                }})
        } else if (_toRatioConfig.text === "Mega Win") {
            this._bigWinSpineAnimAbort.x = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X - 25-10;
        } else if (_toRatioConfig.text === "Super Mega Win") {
        }
        tl.add(()=>{

        },0.5)
        //this._bigWinSpineAnimAbort.state.setAnimation(0, `${levelStr}_end`, true).timeScale =1;

        return tl;
    }
    /**
     * @description To kill the start and loop tween.
     */
    private killTween(): void {
        if (this.mainBigTimeLine) {
            this.mainBigTimeLine!.pause();
            this.mainBigTimeLine!.kill();
        }
    }
}